import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Mail, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const QV_LOGO =
  "https://customer-assets.emergentagent.com/job_athletic-edge-19/artifacts/7jyn9i1w_IMG_2453.PNG";

export default function ProgramThanks() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ loading: true, paid: false, email: "", email_sent: false, error: "" });

  useEffect(() => {
    if (!sessionId) {
      setState({ loading: false, paid: false, error: "Missing session_id.", email: "", email_sent: false });
      return;
    }
    let alive = true;
    let attempts = 0;
    const MAX_ATTEMPTS = 12; // ~24 seconds
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/programs/checkout/status/${sessionId}`);
        if (!alive) return;
        if (data.payment_status === "paid") {
          setState({ loading: false, paid: true, email: data.email || "", email_sent: !!data.email_sent, error: "" });
          return;
        }
        if (attempts < MAX_ATTEMPTS) {
          setTimeout(poll, 2000);
        } else {
          setState({ loading: false, paid: false, email: data.email || "", email_sent: false, error: "El pago está tardando en confirmarse. Comprueba tu email en unos minutos." });
        }
      } catch (e) {
        if (alive) setState({ loading: false, paid: false, error: "No se pudo verificar el pago.", email: "", email_sent: false });
      }
    };
    poll();
    return () => { alive = false; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-5 py-12" data-testid="program-thanks">
      <div className="w-full max-w-lg">
        <div className="flex items-center gap-3 mb-10 justify-center">
          <img src={QV_LOGO} alt="QV" className="h-12 w-12 object-contain" />
          <div>
            <div className="qv-display text-white text-xl">QUIQUE VARGAS</div>
            <div className="text-[10px] tracking-[0.32em] text-neutral-500 uppercase">Performance Coach</div>
          </div>
        </div>

        <div className="border border-white/10 bg-[#0a0a0a] p-8 sm:p-10 text-center">
          {state.loading && (
            <div>
              <div className="qv-overline">CONFIRMANDO PAGO</div>
              <h1 className="qv-display text-white text-3xl mt-4">Un segundo...</h1>
              <p className="mt-3 text-neutral-400 text-sm">Estamos verificando con Stripe. Esto tarda ~10 segundos.</p>
            </div>
          )}

          {!state.loading && state.paid && (
            <div>
              <div className="w-16 h-16 mx-auto rounded-full border border-[color:var(--qv-red)]/50 flex items-center justify-center mb-6"
                   style={{ background: "rgba(225,29,46,0.08)" }}>
                <CheckCircle2 size={32} color="var(--qv-red)" />
              </div>
              <div className="qv-overline">PAGO CONFIRMADO</div>
              <h1 className="qv-display text-white text-3xl sm:text-4xl mt-3">
                ¡Bienvenido!
              </h1>
              <p className="mt-4 text-neutral-300 leading-relaxed" data-testid="thanks-email-line">
                {state.email && (
                  <>Hemos enviado un email a <span className="text-white font-semibold">{state.email}</span> con el enlace para activar tu cuenta.</>
                )}
                {!state.email && "Hemos enviado un email con el enlace para activar tu cuenta."}
              </p>
              <ul className="mt-8 text-left space-y-3 text-sm text-neutral-300">
                <li className="flex items-start gap-2"><Mail size={16} color="var(--qv-red)" className="mt-0.5 shrink-0" /> Revisa tu bandeja (y spam por si acaso).</li>
                <li className="flex items-start gap-2"><CheckCircle2 size={16} color="var(--qv-red)" className="mt-0.5 shrink-0" /> Haz click en &ldquo;Activar mi cuenta&rdquo;.</li>
                <li className="flex items-start gap-2"><ArrowRight size={16} color="var(--qv-red)" className="mt-0.5 shrink-0" /> Elige tu contraseña y accede a tu programa.</li>
              </ul>
              <div className="mt-8">
                <a href="/app/login" className="qv-btn-ghost inline-flex" data-testid="thanks-login-cta">
                  YA TENGO CUENTA — INICIAR SESIÓN
                </a>
              </div>
            </div>
          )}

          {!state.loading && !state.paid && (
            <div>
              <div className="qv-overline text-neutral-400">PAGO PENDIENTE</div>
              <h1 className="qv-display text-white text-3xl mt-3">Un momento...</h1>
              <p className="mt-4 text-neutral-400 text-sm">{state.error || "Todavía estamos esperando la confirmación."}</p>
              <a href="/programas" className="qv-btn-ghost mt-6 inline-flex">Volver a Programas</a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
